export const calculateScreenshotCameraDistance = (
  boundingSphereRadius: number,
  cameraFov = 0.8
): number => {
  // increase by 50 because screenshot is smaller than viewport, so to avoid mesh cutting
  return Math.round(Math.abs(boundingSphereRadius / Math.sin(cameraFov / 2)) + 50);
};
